
export const TEAL = "#168570", TEAL_LIGHT = "#1E9A82";
export const IN_COLOR = "#2A9A7A", OUT_COLOR = "#e24b4a", TR_COLOR = "#378ADD";
export const TYPE_META = {
  entree: { label: "Entrée", color: IN_COLOR },
  sortie: { label: "Sortie", color: OUT_COLOR },
  transfert: { label: "Transfert", color: TR_COLOR },
};
export const STATE_META = {
  recu: { label: "Reçu", color: "#E0A82E" },
  depose: { label: "Déposé", color: "#F59E0B" },
  encaisse: { label: "Encaissé", color: IN_COLOR },
  rejete: { label: "Rejeté", color: OUT_COLOR },
};
export const NATURE_LABEL = { bancaire: "Compte bancaire", caisse: "Caisse" };

const _fmt = (n) => (amountsMasked() ? MASKED : `${(Math.round((Number(n) || 0) * 100) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DA`);
export const fmtDA = _fmt;
export const fmtDARaw = _fmt;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");
export const todayISO = () => new Date().toISOString().slice(0, 10);

export const sel = { background: "#101013", border: "0.5px solid #3a3a42", borderRadius: 7, padding: "6px 9px", color: "#e8e8ec", fontSize: 12, outline: "none" };
export const inp = { ...sel, width: "100%" };
export const cardStyle = { background: "#141418", border: "0.5px solid #26262a", borderRadius: 10 };

import { MASKED, amountsMasked } from "@/components/common/HideAmountsButton";
import { initialsOf } from "@/components/common/UserInitials";

export const initials = (u) => initialsOf(u);

export function TypeBadge({ type, testId }) {
  const m = TYPE_META[type] || TYPE_META.entree;
  return <span style={{ fontSize: 10, padding: "2px 7px", borderRadius: 4, background: `${m.color}29`, color: m.color, fontWeight: 700, letterSpacing: ".03em" }} data-testid={testId}>{m.label.toUpperCase()}</span>;
}

export function StateBadge({ state, testId }) {
  if (!state) return null;
  const m = STATE_META[state] || STATE_META.recu;
  return <span style={{ fontSize: 10, padding: "1px 6px", borderRadius: 4, border: `0.5px solid ${m.color}77`, color: m.color }} data-testid={testId}>{m.label}</span>;
}

export const btnPrimary = { background: TEAL, borderRadius: 9, height: 34, padding: "0 13px", gap: 6, fontSize: 13, color: "#fff" };
export const btnGhost = { background: "#1a1a1e", border: "0.5px solid #2a2a30", borderRadius: 9, height: 34, padding: "0 12px", gap: 6, fontSize: 12.5, color: "#e8e8ec" };
